import { action } from 'mobx';

import { post } from 'services/request';
import Step1 from './Step1';
import Summary from './Summary';
import Results from './Results';

export default class Store {
  steps = [{ key: 'tc', title: 'Accept T&C', implementation: Step1 }];

  summaryClass = Summary;
  resultsClass = Results;

  data = null;
  saleId = null;

  constructor(management) {
    this.source = management.source;
    const { user } = management.source;

    this.data = {
      agentData: user.agentData(),
    };
  }

  @action async submit(saleId, token) {
    const response = await post(
      `/api/v1/wizard/${saleId}/duplicate`,
      this.data,
      token
    );
    this.saleId = response.command.saleId;
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/SaleWizard/Duplicate/index.js